/**
 * Detekce mock režimu z URL (?mock=...) — synchronní helper bez hooku.
 * Použití v `useQuery.enabled` v hookoch sdílených napříč aplikací,
 * aby v mock režimu nezasahovaly BE (K0.1.e ze specu).
 */
export const isMockActive = (): boolean => {
    if (typeof window === 'undefined') return false;
    return new URLSearchParams(window.location.search).has('mock');
};
